import {
  KeycloakService,
  PageRequest,
  PagedResponse,
  Sort
} from '@elotech/components';
import axios, { AxiosPromise, AxiosResponse } from 'axios';

import {
  Revchanges,
  RevisionDiff,
  Usuario,
  UsuarioLogin,
  UsuarioProvider
} from '../type';

const realmUrl = () =>
  `${KeycloakService.getInstance().authServerUrl}/realms/${
    KeycloakService.getInstance().realm
  }`;

export const getUserData = (): AxiosPromise<any> =>
  axios.get(`/painel-api/api/usuario/me`);

export const editUser = (userData: object): AxiosPromise<any> =>
  axios.put(`${realmUrl()}/usuario/me`, userData);

export const userExists = (): AxiosPromise<any> =>
  axios.get(`/gateway/public/user-exists`);

export const getUserProviders = (
  userId: string
): AxiosPromise<UsuarioProvider> =>
  axios.get(`/painel-api/api/usuario/${userId}/providers`);

export const removeProviderLinkFromUser = (
  userId: string,
  provider: string
): AxiosPromise<void> =>
  axios.delete(`${realmUrl()}/usuario/providers/${userId}/${provider}`);

export const removeProviderLink = (
  userId: string,
  provider: string,
  isExterno: boolean = false
): AxiosPromise<void> =>
  axios.delete(`/painel-api/api/usuario/${userId}/providers/${provider}`, {
    params: { isExterno }
  });

export const resetPassword = (
  usuarioId: string,
  passwordObject: {
    password: string;
    temporaryPassword: boolean;
  }
): AxiosPromise<any> =>
  axios.put(
    `${realmUrl()}/usuario/${usuarioId}/reset-password/`,
    passwordObject
  );

export const getCurrentUserLastLogins = (): AxiosPromise<UsuarioLogin[]> =>
  axios.get(`${realmUrl()}/usuario/me/login`);

// Autocomplete de usuários do tenant (copiar permissões, personificação): pelo painel-api, não pela SPI.
export const getUsuarios = (
  search: string
): Promise<AxiosResponse<Usuario[]>> =>
  axios
    .get('/painel-api/api/usuario', { params: { search, size: 20 } })
    .then(response => ({ ...response, data: response.data.content }));

export const copyUserPemissons = (
  userIdFrom: string,
  userIdTo: string
): AxiosPromise<void> => {
  return axios.post(`/painel-api/api/usuario/copy-user-permissions`, {
    userIdFrom,
    userIdTo
  });
};

export const findById = (userId: string): AxiosPromise<Usuario> =>
  axios.get(`/painel-api/api/usuario/${userId}`);

export const getActiveSessions = () =>
  axios.get('/painel-api/api/usuario/me/session');

export const encerrarTodasSessoes = () =>
  axios.delete(`${realmUrl()}/usuario/me/session`);

export const encerrarSessaoPorId = (idSessao: string) =>
  axios.delete(`${realmUrl()}/usuario/me/session/${idSessao}`);

export const getHistoricoAuditoria = (
  id: string,
  className: string,
  page?: PageRequest,
  sort?: Sort
): AxiosPromise<PagedResponse<Revchanges>> =>
  axios.get(`/painel-api/api/usuario/${id}/history/${className}`, {
    params: {
      ...page,
      ...sort
    }
  });
export const getAlteracoesOnRevision = (
  id: string,
  className: string,
  revision: number
): AxiosPromise<RevisionDiff[]> =>
  axios.get(`/painel-api/api/usuario/${id}/history/${className}/${revision}`);

export const getImpersonationHistory = (
  userId: string,
  page?: PageRequest,
  sort?: Sort
): AxiosPromise<PagedResponse<any>> =>
  axios.get(`/painel-api/api/usuario/${userId}/impersonations`, {
    params: {
      ...page,
      ...sort
    }
  });
